import { motion } from "framer-motion";
import { useContext, useEffect, useState } from "react";
import { ChromePicker } from "react-color";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import ModalAtualizar from "../../../../components/ModalAtualizar/ModalAtualizar.tsx";
import NavbarV3 from "../../../../components/NavbarV3/NavbarV3.tsx";
import SemAutorizacao from "../../../../components/SemAutorizacao/SemAutorizacao";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import NomeTabelaRedux from "../../../../contexts/NomeTabela";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";
import {
	editaEmpresa,
	getEmpresaPorId,
} from "../../../../services/ModuloGerenciador/Administrativo";
import "./ConfiguracoesCores.css";

function ConfiguracoesCores() {
	const { dadosTabelaRedux, setDadosTabelaRedux } = useContext(NomeTabelaRedux);

	const { profile, setCoresEmpresa, hasRegra, coresEmpresa } = useProfile();

	const [colorHeaderFooter, setColorHeaderFooter] = useState(
		coresEmpresa.headerFooter
	);

	const [showColorHeaderFooter, setShowColorHeaderFooter] = useState(false);

	const [colorFundoPadrao, setColorFundoPadrao] = useState(
		coresEmpresa.fundoPadrao
	);

	const [showColorFundoPadrao, setShowColorFundoPadrao] = useState(false);

	const [colorBotaoSelecionado, setColorBotaoSelecionado] = useState(
		coresEmpresa.botaoSelecionado
	);

	const [showColorBotaoSelecionado, setShowColorBotaoSelecionado] =
		useState(false);

	const [colorBotaoPadrao, setColorBotaoPadrao] = useState(
		coresEmpresa.botaoPadrao
	);

	const [showColorBotaoPadrao, setShowColorBotaoPadrao] = useState(false);

	const [colorTextoBotaoSelecionado, setColorTextoBotaoSelecionado] = useState(
		coresEmpresa.textoBotaoSelecionado
	);

	const [showColorTextoBotaoSelecionado, setShowColorTextoBotaoSelecionado] =
		useState(false);

	const [colorTextoBotaoPadrao, setColorTextoBotaoPadrao] = useState(
		coresEmpresa.textoBotaoPadrao
	);
	const [showColorTextoBotaoPadrao, setShowColorTextoBotaoPadrao] =
		useState(false);

	const [colorTextosInputs, setColorTextosInputs] = useState(
		coresEmpresa.textosInputs
	);
	const [showColorTextosInputs, setShowColorTextosInputs] = useState(false);

	const [colorBotaoSecundario, setColorBotaoSecundario] = useState(
		coresEmpresa.botaoSecundario
	);
	const [showColorBotaoSecundario, setShowColorBotaoSecundario] =
		useState(false);

	const [colorTextoBotaoSecundario, setColorTextoBotaoSecundario] = useState(
		coresEmpresa.textoBotaoSecundario
	);
	const [showColorTextoBotaoSecundario, setShowColorTextoBotaoSecundario] =
		useState(false);

	const [colorTituloColuna, setColorTituloColuna] = useState(
		coresEmpresa.tituloColuna
	);
	const [showColorTituloColuna, setShowColorTituloColuna] = useState(false);

	const [colorTextoTituloColuna, setColorTextoTituloColuna] = useState(
		coresEmpresa.textoTituloColuna
	);
	const [showColorTextoTituloColuna, setShowColorTextoTituloColuna] =
		useState(false);

	const [colorBordaTituloColuna, setColorBordaTituloColuna] = useState(
		coresEmpresa.bordaTituloColuna
	);
	const [showColorBordaTituloColuna, setShowColorBordaTituloColuna] =
		useState(false);

	const [colorColuna, setColorColuna] = useState(coresEmpresa.coluna);
	const [showColorColuna, setShowColorColuna] = useState(false);

	const [colorTextoColuna, setColorTextoColuna] = useState(
		coresEmpresa.textoColuna
	);
	const [showColorTextoColuna, setShowColorTextoColuna] = useState(false);

	const [colorBotaoMenu, setColorBotaoMenu] = useState(coresEmpresa.botaoMenu);
	const [showColorBotaoMenu, setShowColorBotaoMenu] = useState(false);

	const [colorFundoMenu, setColorFundoMenu] = useState(coresEmpresa.fundoMenu);
	const [showColorFundoMenu, setShowColorFundoMenu] = useState(false);

	const [colorTextoBotaoNormal, setColorTextoBotaoNormal] = useState(
		coresEmpresa.textoBotaoNormal
	);
	const [showColorTextoBotaoNormal, setShowColorTextoBotaoNormal] =
		useState(false);

	const [open, setOpen] = useState(false);

	const [jaPassou, setJaPassou] = useState(false);

	const [loading, setLoading] = useState(false);

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const [openToastErro, setOpenToastErro] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const handleClose = (value) => {
		setOpen(false);
	};

	const cadastrar = async () => {
		setLoading(true);
		try {
			await getEmpresaPorId({ tenant: localStorage.getItem("tenant") }).then(
				(result) => {
					if (result.status === 200) {
						const nomeColuna = result.data.colunas.replace(/'/g, '"');
						const colunas = JSON.parse(nomeColuna);
						setDadosTabelaRedux(colunas);
						const objeto = {
							tenant: localStorage.getItem("tenant"),
							cores: JSON.stringify(coresEmpresa).replace(/"/g, `'`),
							colunas: JSON.stringify(dadosTabelaRedux).replace(/"/g, `'`),
						};
						editaEmpresa(profile?.token, objeto)
							.then((result) => {
								if (result.status === 200) {
									if (!jaPassou) {
										setOpen(true);
									}
									setJaPassou(true);
									setTextoSucesso("Configurações Atualizadas com Sucesso!");
									setOpenToastSucesso(true);
								}
							})
							.catch((error) => {
								console.error(error);
								setTextoErro(error.response.data);
								setOpenToastErro(true);
							});
					}
				}
			);
		} catch (error) {
			console.error(error);
			setTextoErro(error.response.data);
			setOpenToastErro(true);
		}
	};

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (!profile?.id) return;
		setSemAutorizacao(!hasRegra("Configuracoes"));
	}, [profile]);

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			{semAutorizacao ? (
				<>
					<NavbarV3
						title="Painel Configurações Cores"
						selecionado="ConfiguracoesCores"
					/>
					<SemAutorizacao></SemAutorizacao>
				</>
			) : (
				<div>
					<NavbarV3
						title="Painel Configurações Cores"
						selecionado="ConfiguracoesCores"
					/>
					{!loading ? (
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
							className="corpo-cores"
						>
							<div className="botoes-cores">
								<p className="titulo-configs">Cores Fundo</p>
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo={showColorHeaderFooter ? "FECHAR" : "Fundo Superior"}
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setShowColorHeaderFooter(
											(showColorHeaderFooter) => !showColorHeaderFooter
										);
										setShowColorFundoPadrao(false);
										setShowColorBotaoSelecionado(false);
										setShowColorBotaoPadrao(false);
										setShowColorTextoBotaoSelecionado(false);
										setShowColorTextoBotaoPadrao(false);
										setShowColorTextosInputs(false);
										setShowColorBotaoSecundario(false);
										setShowColorTextoBotaoSecundario(false);
										setShowColorTituloColuna(false);
										setShowColorTextoTituloColuna(false);
										setShowColorBordaTituloColuna(false);
										setShowColorColuna(false);
										setShowColorTextoColuna(false);
										setShowColorBotaoMenu(false);
										setShowColorFundoMenu(false);
										setShowColorTextoBotaoNormal(false);
									}}
								/>
								{showColorHeaderFooter && (
									<div>
										<p>Fundo Superior</p>
										<ChromePicker
											color={colorHeaderFooter}
											onChange={(updatedColor) =>
												setColorHeaderFooter(updatedColor.hex)
											}
										/>
									</div>
								)}
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo={showColorFundoPadrao ? "FECHAR" : "Fundo Padrão"}
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setShowColorFundoPadrao(
											(showColorFundoPadrao) => !showColorFundoPadrao
										);
										setShowColorHeaderFooter(false);
										setShowColorBotaoSelecionado(false);
										setShowColorBotaoPadrao(false);
										setShowColorTextoBotaoSelecionado(false);
										setShowColorTextoBotaoPadrao(false);
										setShowColorTextosInputs(false);
										setShowColorBotaoSecundario(false);
										setShowColorTextoBotaoSecundario(false);
										setShowColorTituloColuna(false);
										setShowColorTextoTituloColuna(false);
										setShowColorBordaTituloColuna(false);
										setShowColorColuna(false);
										setShowColorTextoColuna(false);
										setShowColorBotaoMenu(false);
										setShowColorFundoMenu(false);
										setShowColorTextoBotaoNormal(false);
									}}
								/>
								{showColorFundoPadrao && (
									<div>
										<p>Fundo Padrão</p>
										<ChromePicker
											color={colorFundoPadrao}
											onChange={(updatedColor) =>
												setColorFundoPadrao(updatedColor.hex)
											}
										/>
									</div>
								)}
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo={showColorFundoMenu ? "FECHAR" : "Fundo Menu"}
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setShowColorFundoMenu(
											(showColorFundoMenu) => !showColorFundoMenu
										);
										setShowColorHeaderFooter(false);
										setShowColorFundoPadrao(false);
										setShowColorBotaoSelecionado(false);
										setShowColorBotaoPadrao(false);
										setShowColorTextoBotaoSelecionado(false);
										setShowColorTextoBotaoPadrao(false);
										setShowColorTextosInputs(false);
										setShowColorBotaoSecundario(false);
										setShowColorTextoBotaoSecundario(false);
										setShowColorTituloColuna(false);
										setShowColorTextoTituloColuna(false);
										setShowColorBordaTituloColuna(false);
										setShowColorColuna(false);
										setShowColorTextoColuna(false);
										setShowColorBotaoMenu(false);
										setShowColorTextoBotaoNormal(false);
									}}
								/>
								{showColorFundoMenu && (
									<div>
										<p>Fundo Menu</p>
										<ChromePicker
											color={colorFundoMenu}
											onChange={(updatedColor) =>
												setColorFundoMenu(updatedColor.hex)
											}
										/>
									</div>
								)}
							</div>
							<div className="botoes-cores">
								<p className="titulo-configs">Cores Botões</p>
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo={showColorBotaoPadrao ? "FECHAR" : "Botão Padrão"}
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setShowColorBotaoPadrao(
											(showColorBotaoPadrao) => !showColorBotaoPadrao
										);
										setShowColorHeaderFooter(false);
										setShowColorFundoPadrao(false);
										setShowColorBotaoSelecionado(false);
										setShowColorTextoBotaoSelecionado(false);
										setShowColorTextoBotaoPadrao(false);
										setShowColorTextosInputs(false);
										setShowColorBotaoSecundario(false);
										setShowColorTextoBotaoSecundario(false);
										setShowColorTituloColuna(false);
										setShowColorTextoTituloColuna(false);
										setShowColorBordaTituloColuna(false);
										setShowColorColuna(false);
										setShowColorTextoColuna(false);
										setShowColorBotaoMenu(false);
										setShowColorFundoMenu(false);
										setShowColorTextoBotaoNormal(false);
									}}
								/>
								{showColorBotaoPadrao && (
									<div>
										<p>Botão Padrão</p>
										<ChromePicker
											color={colorBotaoPadrao}
											onChange={(updatedColor) =>
												setColorBotaoPadrao(updatedColor.hex)
											}
										/>
									</div>
								)}
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo={
										showColorBotaoSecundario ? "FECHAR" : "Botão Secundário"
									}
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setShowColorBotaoSecundario(
											(showColorBotaoSecundario) => !showColorBotaoSecundario
										);
										setShowColorHeaderFooter(false);
										setShowColorFundoPadrao(false);
										setShowColorBotaoSelecionado(false);
										setShowColorBotaoPadrao(false);
										setShowColorTextoBotaoSelecionado(false);
										setShowColorTextoBotaoPadrao(false);
										setShowColorTextosInputs(false);
										setShowColorTextoBotaoSecundario(false);
										setShowColorTituloColuna(false);
										setShowColorTextoTituloColuna(false);
										setShowColorBordaTituloColuna(false);
										setShowColorColuna(false);
										setShowColorTextoColuna(false);
										setShowColorBotaoMenu(false);
										setShowColorFundoMenu(false);
										setShowColorTextoBotaoNormal(false);
									}}
								/>
								{showColorBotaoSecundario && (
									<div>
										<p>Botão Secundário</p>
										<ChromePicker
											color={colorBotaoSecundario}
											onChange={(updatedColor) =>
												setColorBotaoSecundario(updatedColor.hex)
											}
										/>
									</div>
								)}
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo={showColorBotaoMenu ? "FECHAR" : "Botão Menu"}
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setShowColorBotaoMenu(
											(showColorBotaoMenu) => !showColorBotaoMenu
										);
										setShowColorHeaderFooter(false);
										setShowColorFundoPadrao(false);
										setShowColorBotaoSelecionado(false);
										setShowColorBotaoPadrao(false);
										setShowColorTextoBotaoSelecionado(false);
										setShowColorTextoBotaoPadrao(false);
										setShowColorTextosInputs(false);
										setShowColorBotaoSecundario(false);
										setShowColorTextoBotaoSecundario(false);
										setShowColorTituloColuna(false);
										setShowColorTextoTituloColuna(false);
										setShowColorBordaTituloColuna(false);
										setShowColorColuna(false);
										setShowColorTextoColuna(false);
										setShowColorFundoMenu(false);
										setShowColorTextoBotaoNormal(false);
									}}
								/>
								{showColorBotaoMenu && (
									<div>
										<p>Botão Menu</p>
										<ChromePicker
											color={colorBotaoMenu}
											onChange={(updatedColor) =>
												setColorBotaoMenu(updatedColor.hex)
											}
										/>
									</div>
								)}
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo={
										showColorBotaoSelecionado ? "FECHAR" : "Botão Selecionado"
									}
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setShowColorBotaoSelecionado(
											(showColorBotaoSelecionado) => !showColorBotaoSelecionado
										);
										setShowColorHeaderFooter(false);
										setShowColorFundoPadrao(false);
										setShowColorBotaoPadrao(false);
										setShowColorTextoBotaoSelecionado(false);
										setShowColorTextoBotaoPadrao(false);
										setShowColorTextosInputs(false);
										setShowColorBotaoSecundario(false);
										setShowColorTextoBotaoSecundario(false);
										setShowColorTituloColuna(false);
										setShowColorTextoTituloColuna(false);
										setShowColorBordaTituloColuna(false);
										setShowColorColuna(false);
										setShowColorTextoColuna(false);
										setShowColorBotaoMenu(false);
										setShowColorFundoMenu(false);
										setShowColorTextoBotaoNormal(false);
									}}
								/>
								{showColorBotaoSelecionado && (
									<div>
										<p>Botão Selecionado</p>
										<ChromePicker
											color={colorBotaoSelecionado}
											onChange={(updatedColor) =>
												setColorBotaoSelecionado(updatedColor.hex)
											}
										/>
									</div>
								)}
							</div>
							<div className="botoes-cores">
								<p className="titulo-configs">Cores Textos</p>
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo={
										showColorTextoBotaoPadrao ? "FECHAR" : "Texto Botão Padrão"
									}
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setShowColorTextoBotaoPadrao(
											(showColorTextoBotaoPadrao) => !showColorTextoBotaoPadrao
										);
										setShowColorHeaderFooter(false);
										setShowColorFundoPadrao(false);
										setShowColorBotaoSelecionado(false);
										setShowColorBotaoPadrao(false);
										setShowColorTextoBotaoSelecionado(false);
										setShowColorTextosInputs(false);
										setShowColorBotaoSecundario(false);
										setShowColorTextoBotaoSecundario(false);
										setShowColorTituloColuna(false);
										setShowColorTextoTituloColuna(false);
										setShowColorBordaTituloColuna(false);
										setShowColorColuna(false);
										setShowColorTextoColuna(false);
										setShowColorBotaoMenu(false);
										setShowColorFundoMenu(false);
										setShowColorTextoBotaoNormal(false);
									}}
								/>
								{showColorTextoBotaoPadrao && (
									<div>
										<p>Texto Botão Padrão</p>
										<ChromePicker
											color={colorTextoBotaoPadrao}
											onChange={(updatedColor) =>
												setColorTextoBotaoPadrao(updatedColor.hex)
											}
										/>
									</div>
								)}
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo={
										showColorTextoBotaoNormal ? "FECHAR" : "Texto Botão Normal"
									}
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setShowColorTextoBotaoNormal(
											(showColorTextoBotaoNormal) => !showColorTextoBotaoNormal
										);
										setShowColorHeaderFooter(false);
										setShowColorFundoPadrao(false);
										setShowColorBotaoSelecionado(false);
										setShowColorBotaoPadrao(false);
										setShowColorTextoBotaoSelecionado(false);
										setShowColorTextoBotaoPadrao(false);
										setShowColorTextosInputs(false);
										setShowColorBotaoSecundario(false);
										setShowColorTextoBotaoSecundario(false);
										setShowColorTituloColuna(false);
										setShowColorTextoTituloColuna(false);
										setShowColorBordaTituloColuna(false);
										setShowColorColuna(false);
										setShowColorTextoColuna(false);
										setShowColorBotaoMenu(false);
										setShowColorFundoMenu(false);
									}}
								/>
								{showColorTextoBotaoNormal && (
									<div>
										<p>Texto Botão Normal</p>
										<ChromePicker
											color={colorTextoBotaoNormal}
											onChange={(updatedColor) =>
												setColorTextoBotaoNormal(updatedColor.hex)
											}
										/>
									</div>
								)}
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo={
										showColorTextoBotaoSelecionado
											? "FECHAR"
											: "Texto Botão Selecionado"
									}
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setShowColorTextoBotaoSelecionado(
											(showColorTextoBotaoSelecionado) =>
												!showColorTextoBotaoSelecionado
										);
										setShowColorHeaderFooter(false);
										setShowColorFundoPadrao(false);
										setShowColorBotaoSelecionado(false);
										setShowColorBotaoPadrao(false);
										setShowColorTextoBotaoPadrao(false);
										setShowColorTextosInputs(false);
										setShowColorBotaoSecundario(false);
										setShowColorTextoBotaoSecundario(false);
										setShowColorTituloColuna(false);
										setShowColorTextoTituloColuna(false);
										setShowColorBordaTituloColuna(false);
										setShowColorColuna(false);
										setShowColorTextoColuna(false);
										setShowColorBotaoMenu(false);
										setShowColorFundoMenu(false);
										setShowColorTextoBotaoNormal(false);
									}}
								/>
								{showColorTextoBotaoSelecionado && (
									<div>
										<p>Texto Botão Selecionado</p>
										<ChromePicker
											color={colorTextoBotaoSelecionado}
											onChange={(updatedColor) =>
												setColorTextoBotaoSelecionado(updatedColor.hex)
											}
										/>
									</div>
								)}
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo={
										showColorTextoBotaoSecundario
											? "FECHAR"
											: "Texto Botão Secundário"
									}
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setShowColorTextoBotaoSecundario(
											(showColorTextoBotaoSecundario) =>
												!showColorTextoBotaoSecundario
										);
										setShowColorHeaderFooter(false);
										setShowColorFundoPadrao(false);
										setShowColorBotaoSelecionado(false);
										setShowColorBotaoPadrao(false);
										setShowColorTextoBotaoSelecionado(false);
										setShowColorTextoBotaoPadrao(false);
										setShowColorTextosInputs(false);
										setShowColorBotaoSecundario(false);
										setShowColorTituloColuna(false);
										setShowColorTextoTituloColuna(false);
										setShowColorBordaTituloColuna(false);
										setShowColorColuna(false);
										setShowColorTextoColuna(false);
										setShowColorBotaoMenu(false);
										setShowColorFundoMenu(false);
										setShowColorTextoBotaoNormal(false);
									}}
								/>
								{showColorTextoBotaoSecundario && (
									<div>
										<p>Texto Botão Secundário</p>
										<ChromePicker
											color={colorTextoBotaoSecundario}
											onChange={(updatedColor) =>
												setColorTextoBotaoSecundario(updatedColor.hex)
											}
										/>
									</div>
								)}
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo={
										showColorTextosInputs ? "FECHAR" : "Título Caixa de Texto"
									}
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setShowColorTextosInputs(
											(showColorTextosInputs) => !showColorTextosInputs
										);
										setShowColorHeaderFooter(false);
										setShowColorFundoPadrao(false);
										setShowColorBotaoSelecionado(false);
										setShowColorBotaoPadrao(false);
										setShowColorTextoBotaoSelecionado(false);
										setShowColorTextoBotaoPadrao(false);
										setShowColorBotaoSecundario(false);
										setShowColorTextoBotaoSecundario(false);
										setShowColorTituloColuna(false);
										setShowColorTextoTituloColuna(false);
										setShowColorBordaTituloColuna(false);
										setShowColorColuna(false);
										setShowColorTextoColuna(false);
										setShowColorBotaoMenu(false);
										setShowColorFundoMenu(false);
										setShowColorTextoBotaoNormal(false);
									}}
								/>
								{showColorTextosInputs && (
									<div>
										<p>Título Caixa de Texto</p>
										<ChromePicker
											color={colorTextosInputs}
											onChange={(updatedColor) =>
												setColorTextosInputs(updatedColor.hex)
											}
										/>
									</div>
								)}
							</div>
							<div className="botoes-cores">
								<p className="titulo-configs">Cores Tabela</p>
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo={showColorTituloColuna ? "FECHAR" : "Titulo Coluna"}
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setShowColorTituloColuna(
											(showColorTituloColuna) => !showColorTituloColuna
										);
										setShowColorHeaderFooter(false);
										setShowColorFundoPadrao(false);
										setShowColorBotaoSelecionado(false);
										setShowColorBotaoPadrao(false);
										setShowColorTextoBotaoSelecionado(false);
										setShowColorTextoBotaoPadrao(false);
										setShowColorTextosInputs(false);
										setShowColorBotaoSecundario(false);
										setShowColorTextoBotaoSecundario(false);
										setShowColorTextoTituloColuna(false);
										setShowColorBordaTituloColuna(false);
										setShowColorColuna(false);
										setShowColorTextoColuna(false);
										setShowColorBotaoMenu(false);
										setShowColorFundoMenu(false);
										setShowColorTextoBotaoNormal(false);
									}}
								/>
								{showColorTituloColuna && (
									<div>
										<p>Titulo Coluna</p>
										<ChromePicker
											color={colorTituloColuna}
											onChange={(updatedColor) =>
												setColorTituloColuna(updatedColor.hex)
											}
										/>
									</div>
								)}
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo={
										showColorTextoTituloColuna
											? "FECHAR"
											: "Texto Titulo Coluna"
									}
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setShowColorTextoTituloColuna(
											(showColorTextoTituloColuna) =>
												!showColorTextoTituloColuna
										);
										setShowColorHeaderFooter(false);
										setShowColorFundoPadrao(false);
										setShowColorBotaoSelecionado(false);
										setShowColorBotaoPadrao(false);
										setShowColorTextoBotaoSelecionado(false);
										setShowColorTextoBotaoPadrao(false);
										setShowColorTextosInputs(false);
										setShowColorBotaoSecundario(false);
										setShowColorTextoBotaoSecundario(false);
										setShowColorTituloColuna(false);
										setShowColorBordaTituloColuna(false);
										setShowColorColuna(false);
										setShowColorTextoColuna(false);
										setShowColorBotaoMenu(false);
										setShowColorFundoMenu(false);
										setShowColorTextoBotaoNormal(false);
									}}
								/>
								{showColorTextoTituloColuna && (
									<div>
										<p>Texto Titulo Coluna</p>
										<ChromePicker
											color={colorTextoTituloColuna}
											onChange={(updatedColor) =>
												setColorTextoTituloColuna(updatedColor.hex)
											}
										/>
									</div>
								)}
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo={
										showColorBordaTituloColuna
											? "FECHAR"
											: "Borda Titulo Coluna"
									}
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setShowColorBordaTituloColuna(
											(showColorBordaTituloColuna) =>
												!showColorBordaTituloColuna
										);
										setShowColorHeaderFooter(false);
										setShowColorFundoPadrao(false);
										setShowColorBotaoSelecionado(false);
										setShowColorBotaoPadrao(false);
										setShowColorTextoBotaoSelecionado(false);
										setShowColorTextoBotaoPadrao(false);
										setShowColorTextosInputs(false);
										setShowColorBotaoSecundario(false);
										setShowColorTextoBotaoSecundario(false);
										setShowColorTituloColuna(false);
										setShowColorTextoTituloColuna(false);
										setShowColorColuna(false);
										setShowColorTextoColuna(false);
										setShowColorBotaoMenu(false);
										setShowColorFundoMenu(false);
										setShowColorTextoBotaoNormal(false);
									}}
								/>
								{showColorBordaTituloColuna && (
									<div>
										<p>Borda Titulo Coluna</p>
										<ChromePicker
											color={colorBordaTituloColuna}
											onChange={(updatedColor) =>
												setColorBordaTituloColuna(updatedColor.hex)
											}
										/>
									</div>
								)}
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo={showColorColuna ? "FECHAR" : "Coluna"}
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setShowColorColuna((showColorColuna) => !showColorColuna);
										setShowColorHeaderFooter(false);
										setShowColorFundoPadrao(false);
										setShowColorBotaoSelecionado(false);
										setShowColorBotaoPadrao(false);
										setShowColorTextoBotaoSelecionado(false);
										setShowColorTextoBotaoPadrao(false);
										setShowColorTextosInputs(false);
										setShowColorBotaoSecundario(false);
										setShowColorTextoBotaoSecundario(false);
										setShowColorTituloColuna(false);
										setShowColorTextoTituloColuna(false);
										setShowColorBordaTituloColuna(false);
										setShowColorTextoColuna(false);
										setShowColorBotaoMenu(false);
										setShowColorFundoMenu(false);
										setShowColorTextoBotaoNormal(false);
									}}
								/>
								{showColorColuna && (
									<div>
										<p>Coluna</p>
										<ChromePicker
											color={colorColuna}
											onChange={(updatedColor) =>
												setColorColuna(updatedColor.hex)
											}
										/>
									</div>
								)}
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo={showColorTextoColuna ? "FECHAR" : "Texto Coluna"}
									cor={coresEmpresa.botaoPadrao}
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setShowColorTextoColuna(
											(showColorTextoColuna) => !showColorTextoColuna
										);
										setShowColorHeaderFooter(false);
										setShowColorFundoPadrao(false);
										setShowColorBotaoSelecionado(false);
										setShowColorBotaoPadrao(false);
										setShowColorTextoBotaoSelecionado(false);
										setShowColorTextoBotaoPadrao(false);
										setShowColorTextosInputs(false);
										setShowColorBotaoSecundario(false);
										setShowColorTextoBotaoSecundario(false);
										setShowColorTituloColuna(false);
										setShowColorTextoTituloColuna(false);
										setShowColorBordaTituloColuna(false);
										setShowColorColuna(false);
										setShowColorBotaoMenu(false);
										setShowColorFundoMenu(false);
										setShowColorTextoBotaoNormal(false);
									}}
								/>
								{showColorTextoColuna && (
									<div>
										<p>Texto Coluna</p>
										<ChromePicker
											color={colorTextoColuna}
											onChange={(updatedColor) =>
												setColorTextoColuna(updatedColor.hex)
											}
										/>
									</div>
								)}
							</div>
							<div className="botoes-cores">
								<CustomButton
									classCss="custom-button-margin-giant"
									titulo="Salvar"
									cor="#008000"
									corTexto={coresEmpresa.textoBotaoPadrao}
									onClick={() => {
										setCoresEmpresa({
											headerFooter: colorHeaderFooter,
											fundoPadrao: colorFundoPadrao,
											botaoSelecionado: colorBotaoSelecionado,
											botaoPadrao: colorBotaoPadrao,
											textoBotaoSelecionado: colorTextoBotaoSelecionado,
											textoBotaoPadrao: colorTextoBotaoPadrao,
											textosInputs: colorTextosInputs,
											botaoSecundario: colorBotaoSecundario,
											textoBotaoSecundario: colorTextoBotaoSecundario,
											tituloColuna: colorTituloColuna,
											textoTituloColuna: colorTextoTituloColuna,
											bordaTituloColuna: colorBordaTituloColuna,
											coluna: colorColuna,
											textoColuna: colorTextoColuna,
											botaoMenu: colorBotaoMenu,
											fundoMenu: colorFundoMenu,
											textoBotaoNormal: colorTextoBotaoNormal,
										});
										cadastrar();
									}}
								/>
							</div>
						</motion.div>
					) : (
						<LoadingComponent />
					)}
					<div>
						<ModalAtualizar
							titulo="Cores"
							texto="Clique no botão para atualizar a Página!"
							open={open}
							onClose={handleClose}
							onClick={cadastrar}
						/>
						<ToastSucesso
							texto={textoSucesso}
							open={openToastSucesso}
							onClose={handleCloseToastSucesso}
						/>
						<ToastErro
							texto={textoErro}
							open={openToastErro}
							onClose={handleCloseToastErro}
						/>
					</div>
				</div>
			)}
		</motion.div>
	);
}

export default ConfiguracoesCores;
